// Handle immobilize targeting
const targetImmobilize = (targetZone, targetIndex, ws, setError, setImmobilizeTargetMode, setSelectedImmobilizeWeaponId) => {
  if (!ws || ws.readyState !== 1) {
    setError("Connection lost. Please refresh the page.");
    return;
  }

  // Send immobilize targeting action
  const action = {
    type: "targetImmobilize", 
    targetUnitId: "opponent",
    targetZone: targetZone,
    targetIndex: targetIndex
  };

  ws.send(JSON.stringify(action));
  
  // Reset immobilize targeting
  setImmobilizeTargetMode(false);
  setSelectedImmobilizeWeaponId(null);
};

export default targetImmobilize;
